import React, { useState, useRef, useEffect } from "react";
import { Alert, Button, Form } from "react-bootstrap";
import { GET, POST } from "../Database/RealtimeDatabase";
import { GetPerksFileNames, GetPerkImage } from "../Database/Functions";
import Header from "../UI/Header/Header";
import IconList from "../UI/IconList/IconList";
import Icon from "../UI/Icon/Icon";

export default function ServicePagePerks() {
  const [alert, setAlert] = useState();
  const [loadingPerks, setIsLoadingPerks] = useState(false);
  const [perks, setPerks] = useState([]);
  const [hasUpdates, setHasUpdates] = useState(false);
  const perkRef = useRef();
  const perkIconRef = useRef();

  const perkIcons = GetPerksFileNames();

  const submitPerksHandler = () => {
    setAlert(false);
    const newPerk = {
      name: perkRef.current.value,
      icon: perkIconRef.current.value,
    };
    POST(newPerk, "perks").then(() => {
      setAlert(newPerk.name + " добавлена");
      setHasUpdates(true);
    });
  };

  //Load Perks
  useEffect(() => {
    setIsLoadingPerks(true);
    GET("perks").then((items) => {
      setIsLoadingPerks(false);
      setPerks(items);
      setHasUpdates(false);
    });
  }, [hasUpdates]);

  return (
    <>
      <Form className="Form">
        <Form.Group className="Form__group">
          <Header>Достижения</Header>
          <p>Каталог ачивок, которые выдаются в виде иконок.</p>
          <h4>Доступные:</h4>
          <IconList layout="vertical">
            {perks.map((perk,i) => (
              <Icon image={perk.icon} title={perk.name} className="List__item" size="s" key={i}/>
            ))}
          </IconList>
          <br/>
          <h4>Добавить новую</h4>
          <Form.Control
            type="text"
            ref={perkRef}
            required
            placeholder="Назване достижения"
          />
          <Form.Select ref={perkIconRef}>
            {perkIcons.map((icon, i) => (
              <option value={icon} key={i}>
                {icon}
              </option>
            ))}
          </Form.Select>
          <Button onClick={submitPerksHandler} className="Form__submit">
            Добавить ачивку
          </Button>
        </Form.Group>
      </Form>
      {alert && <Alert variant="success">{alert}</Alert>}
    </>
  );
}
